import Cookies from "js-cookie";

export const getCurrentFacebookClickId = () => {
  return Cookies.get('_fbc');
};
